module.exports = __webpack_public_path__ + "static/media/defaultImg.5f3a56e6.png";